/***********************************
  ContactFormSelector Module
************************************/

Quad.ContactFormSelector = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  var $formSelector,
      $formSection,
      $formOptions,
      $formContainer;


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    $formSelector = $( '#form-type-selector' );
    $formSection = $( '#form-section' );
    $formOptions = $formSelector.find( 'option' );
    $formContainer = $( '.fieldset' );

    _setInitialFormState();
    _addEvents();
    _createCustomDropdowns();

  }

  function _addEvents() {
    $formSelector.on( 'change', function() {
      $( 'html, body' ).animate({ scrollTop: $formSection.offset().top });
      _setFormToShow();
    });
  }


  function _setFormToShow() {
    $('.footnote').show();
    $('#submit').show();
    _resetClassList(); 
    _showSelectedForm();
  }


  function _resetClassList() {
    $formOptions.each( function() {
      $formContainer.removeClass( $( '.form-type-selector option[selected="selected"]' ).val().toLowerCase());
    });
    $( 'label.error' ).remove();
  }


  function _showSelectedForm() {
    $formContainer.removeClass( 'general quote supplier media employment investor' );
    $formContainer.addClass( $( '.form-type-selector option[selected="selected"]' ).val().toLowerCase());

    if( $formContainer.hasClass( 'employment' ) ){
      $('.footnote,#submit').hide();
    }
  }


  function _setInitialFormState() {
    if ( typeof inquiry === 'string' && inquiry.length !== null ) {
     
      $formContainer.addClass( inquiry );
      $( '#form-type-selector' ).val( inquiry );
    } else {
      $('.footnote').hide();
      $('#contact-page-form #submit').hide();
    }
  }


  function _createCustomDropdowns() {
    $( '.select-wrapper select' ).each( function() {
      $( this ).after( '<ul class="select-ui"><ul></ul></ul>' );
      $( this ).children( 'option' ).each( function() {
        if ( $( this ).prop( 'disabled' ) == false ) {
          $( this ).parent().siblings( '.select-ui' ).children( 'ul' ).append( '<li><button value="'+$( this ).val()+'">'+$( this ).text()+'</button></li>' );
        } else if ( typeof inquiry === 'string' && inquiry.length !== null && $( this ).parent().hasClass( 'form-type-selector' )) {
          $( this ).parent().siblings( '.select-ui' ).prepend( '<li>'+$( 'option[value="'+inquiry+'"]' ).text()+'</li>' );
        } else {
          $( this ).parent().siblings( '.select-ui' ).prepend( '<li>'+$( this ).text()+'</li>' );
        }
      });
    });

    $( '.select-ui' ).click( function( e ) {
      if( ! $(this).hasClass('active') ){
        // e.preventDefault();
        // e.stopPropagation();
        $( '.select-ui' ).removeClass( 'active' );
        $( this ).addClass( 'active' );
      
        // alert( 'selectui' );

      } else {

        // this works

        $( this ).removeClass( 'active' );

      }

    });

    $( '.select-ui.active' ).click( function( e ) {
      // e.preventDefault();
      // e.stopPropagation();
      $( '.select-ui' ).removeClass( 'active' );

    });

    $( '.select-ui.active > li' ).click( function( e ) {
      // e.preventDefault();
      // e.stopPropagation();
      $( this ).parent().removeClass( 'active' );

    });

    $( '.select-ui button' ).click( function( e ) {
      e.preventDefault();
      e.stopPropagation();
      var val = $( this ).val();
      var text = $( this ).text();
      $( this ).parents( '.select-ui' ).siblings( 'select' ).children( 'option' ).removeAttr( 'selected' );
      $( this ).parents( '.select-ui' ).siblings( 'select' ).children( 'option[value="'+val+'"]' ).attr( 'selected', true );
      $( this ).parents( '.select-ui' ).siblings( 'select' ).val( val );
      $( this ).parents( '.select-ui' ).siblings( 'select' ).trigger( 'change' );
      $( this ).parents( '.select-ui' ).children( 'li:first-child' ).text( text );
      $( '.select-ui.active' ).removeClass( 'active' );
    });

  }

  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();
